<template>
  <rect x="1.59998" y="1.60001" width="5.8" height="5.8" rx="2" fill="currentColor" />
  <rect x="1.59998" y="8.60001" width="5.8" height="5.8" rx="2" fill="currentColor" />
  <rect x="8.59998" y="1.60001" width="5.8" height="5.8" rx="2" fill="currentColor" />
  <rect x="8.59998" y="8.60001" width="5.8" height="5.8" rx="2" fill="currentColor" />
</template>
